import Circle from '../progressCircle/progressCircle';

const AgeCode = ({
  ageCode,
  margin,
}: {
  ageCode?: string;
  margin?: boolean;
}) => {
  return ageCode ? <Circle margin={margin} text={ageCode} /> : null;
};

export default AgeCode;
